import typography from '../typography';
export default {
  root: {
    fontSize: typography.body1.fontSize,
    padding: typography.cellPadding.padding,
  },
  head: typography.overline,
  body: typography.body1,
};
